module.exports = __webpack_public_path__ + "img/Screen Shot 2021-04-18 at 6.57.55 PM.a5d64b8c.png";